import { createModalHook } from '../../hooks/useModal'

export const useOrderAutopayPBIModal = createModalHook()
